<ion-header class="header --w-back-button --underline">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-list class="breadcrumb">
        <ion-item *ngFor="let breadcrumb of breadcrumbs" class="breadcrumb__item" [routerLink]="[breadcrumb.link]" detail="false">
          <span [innerHTML]="breadcrumb.name"></span> <span class="breadcrumb__item__dash">/</span>
        </ion-item>
      </ion-list>
      <ion-back-button [defaultHref]="routes.settings" text="" icon="arrow-back-outline"></ion-back-button>
    </ion-buttons>
    <ion-title>Onboarding</ion-title>
    <ion-buttons slot="end">
      <ion-menu-button class="header__burger" icon="menu-outline" autoHide="false"></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="onboarding --mobile-white">
  <div class="white-wrapper">
    <div class="onboarding__logo">
      <img [src]="logoImagePath" alt="{{ user.name + ' ' + user.lastName }}" class="onboarding__logo__image" />
      <div class="onboarding__logo__detail">
        <p class="onboarding__logo__detail__text" [innerHTML]="'The logo will appear in your website and other marketing material.'"></p>
        <ion-button class="onboarding__logo__detail__button --text --text-logo --remove">
          <ion-icon name="trash-outline"></ion-icon>
          <span [innerHTML]="'Remove current logo'"></span>
        </ion-button>
        <ion-button class="onboarding__logo__detail__button --text --text-logo --upload">
          <ion-icon name="cloud-upload-outline"></ion-icon>
          <span [innerHTML]="'Upload from computer'"></span>
        </ion-button>
      </div>
    </div>
    <div class="onboarding__form">
      <ion-list class="onboarding__form__list">
        <div class="onboarding__form__list__column">
          <ion-item class="onboarding__form__list__item">
            <ion-label class="label onboarding__form__list__item__label" position="stacked" [innerHTML]="'Company Name'"></ion-label>
            <ion-input class="input onboarding__form__list__item__input" value="Sabine Hairdresser"></ion-input>
            <ion-icon class="onboarding__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
          <ion-item class="onboarding__form__list__item">
            <ion-label class="label onboarding__form__list__item__label" position="stacked" [innerHTML]="'Registration Number'"></ion-label>
            <ion-input class="input onboarding__form__list__item__input" value="00009990009787"></ion-input>
            <ion-icon class="onboarding__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
          <ion-item class="onboarding__form__list__item">
            <ion-label class="label onboarding__form__list__item__label" position="stacked" [innerHTML]="'VAT (Optional)'"></ion-label>
            <ion-input class="input onboarding__form__list__item__input" value="GE 0009787"></ion-input>
            <ion-icon class="onboarding__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
        </div>
        <div class="onboarding__form__list__column">
          <ion-item class="onboarding__form__list__item">
            <ion-label class="label onboarding__form__list__item__label" position="stacked" [innerHTML]="'Address'"></ion-label>
            <ion-input class="input onboarding__form__list__item__input" value="Antoni Maria Alcover 28, 07013 Berlin, Germany"></ion-input>
            <ion-icon class="onboarding__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
          <ion-item class="onboarding__form__list__item">
            <ion-label class="label onboarding__form__list__item__label" position="stacked" [innerHTML]="'Registration Office'"></ion-label>
            <ion-input class="input onboarding__form__list__item__input" value="Antoni Maria Alcover 28, 07013 Berlin, Germany"></ion-input>
            <ion-icon class="onboarding__form__list__item__icon --edit" name="create-outline"></ion-icon>
          </ion-item>
        </div>
      </ion-list>
    </div>
    <div class="onboarding__footer">
      <ion-button class="onboarding__footer__button" [innerHTML]="'Start'"></ion-button>
    </div>
  </div>
</ion-content>
